<template>
  <div class="scroll-hide">
  <div class="privacy">
    <div class="header">
      <div class="updateTime bold">更新日期：2024年12月19日</div>
      <div class="effectiveTime bold">生效日期：2024年12月19日</div>
       <div class="bold">更新提示：</div>
      <div class="bold">本版本依据《个人信息保护法》、《未成年人保护法》等相关法律法规更新相关内容，主要修改集中在 “我们收集哪些信息” 、“管理儿童信息”等章节，更清晰、明确地向您告知我们收集儿童个人信息的场景、目的、方式和范围，帮助您更好地管理儿童的个人信息。</div>
      <div class="text">我们致力于保护使用我们产品和服务的儿童的个人信息，本声明中“儿童”，是指不满14周岁的未成年人。《儿童隐私保护声明》（以下简称“本声明”）和<span class="herf" @click="toPrivacy()">《用户隐私协议》</span>旨在向监护人（以下简称“您”）和儿童说明我们如何收集、使用、存储和处理儿童的个人信息，以及我们为您与儿童提供的访问、更正、删除和保护这些信息的方式。除另有约定外，本声明所用术语和缩略词与《用户服务协议》、<span class="herf" @click="toPrivacy()">《用户隐私协议》</span>中的术语和缩略词具有相同的涵义。</div>
    </div>
    <div class="content">
      <div class="section">
        <span class="bold">儿童监护人特别说明：</span>
      </div>
      <div class="text">
        如果您是儿童的监护人（父母或其他监护人），请您仔细阅读和选择是否同意本声明。我们希望您与我们共同保护儿童的个人信息，教育引导儿童增强个人信息保护意识和能力。
      </div>

      <div class="section">
        <span class="bold">儿童特别说明：</span>
      </div>
      <div class="text">
        如果您是儿童，您需要和您的监护人（父母或其他监护人）共同仔细阅读本声明，并在征得监护人同意后，使用我们的产品、服务或向我们提供信息。
      </div>
      <div class="bold">
        请监护人和儿童在仔细阅读并充分理解<span class="herf" @click="toPrivacy()">《用户隐私协议》</span>、具体产品的隐私保护指引和本声明后，由监护人选择是否同意相关隐私政策以及是否同意儿童使用我们的产品和服务。如果监护人不同意相关隐私政策和本声明的内容或不同意提供服务所必要的信息，将可能导致我们的产品和服务无法正常运行，或者无法达到我们拟达到的服务效果，监护人和儿童可能无法正常使用我们的产品、服务或相关的具体业务功能。
      </div>
      
      <div class="bold">
        监护人点击“同意”即表示监护人同意我们按照<span class="herf" @click="toPrivacy()">《用户隐私协议》</span>、具体产品的隐私保护指引和本声明的约定收集、使用和处理监护人和儿童的信息。
      </div>
      <div></div>
      <div class="bold">
        请您理解，我们提供的产品和服务中可能包括第三方(如微信, Apple ID)提供的产品和服务。请您注意，该第三方可能收集、使用或处理儿童的相关信息，需要该第三方另行获得监护人的同意。我们建议监护人向儿童告知，在向第三方授权处理其个人信息之前需征得监护人的同意。
      </div>
       <div></div>
      <div class="bold">
        我们提醒您，仔细阅读本声明并确认了解我们对儿童个人信息的处理规则，特别是采用粗体字进行标注提示的部分。
      </div>
      <div class="text">
        如您在阅读本声明过程中有任何疑问或权利请求等个人信息相关事宜的，我们为您提供了专门的反馈渠道，具体参见本声明“联系我们”章节，我们会尽快为您作出解答。
      </div>
      <div class="section">
        <span class="bold">我们收集哪些信息</span>
      </div>
      <div class="text">
        我们严格遵守法律法规的规定及与用户的约定，根据用户选择产品和服务的具体情况，收集监护人和儿童的以下个人信息。
      </div>
      <div class="text">
        当我们根据法律法规及行业管理要求，需要为儿童用户配置保护措施时，我们可能会提示您提供监护人的手机号码、电子邮箱，与我们建立联系。在某些涉及支付的产品和服务中，我们可能会要求监护人填写和绑定监护人的银行卡相关信息，以便监护人知悉和管理儿童的支付行为。
      </div>
       <div class="text">
        在儿童使用产品和服务过程中，我们会要求您提供相关必要的信息，具体请查阅<span class="herf" @click="toPrivacy()">《用户隐私协议》</span>“我们收集的信息”一节。
      </div>
       <div class="text">
        如果我们需要收集监护人或儿童的其他个人信息，我们将再次告知监护人和儿童，并征得监护人的同意。
      </div>
      <div class="bold">
        监护人可以选择是否填写或向我们提供特定的信息。请您理解，监护人如果不填写或不提供某些特定的信息，可能会导致我们的产品和服务无法正常运行，或者无法实现我们拟提供的服务效果，监护人和儿童可能无法正常使用我们的产品、服务或相关的具体业务功能。
      </div>

      <div class="section bold">
        我们如何使用这些信息
      </div>
       <ul>
          <li class="text">验证儿童和监护人身份；</li>
          <li class="text">提供必要的产品和服务、产品和服务的具体功能；</li>
          <li class="text">用于优化产品和服务、安全保障；</li>
          <li class="text">如果我们需要超出上述用途使用监护人或儿童的个人信息，我们将再次告知监护人和儿童，并征得监护人的同意。</li>
      </ul>
       <div class="section bold">
        管理、披露儿童个人信息
      </div>
      <div class="text">
        我们遵照法律法规的规定，严格管理儿童的个人信息。
      </div>
      <div class="bold">
          我们仅在监护人事先同意并采取符合《个人信息保护法》等法律法规要求的相关合规措施的情况下，才可能与监护人共享儿童的个人信息:
      </div>
      <div class="bold">
          例如，我们会将部分儿童个人信息（如儿童用户名、账号，以及该儿童在我们某些产品和服务中的支付记录等）与监护人进行共享，监护人可以访问和管理相关个人信息。
      </div>
      <div class="bold">
          发生合并、收购、资产转让等
      </div>
      <div class="bold">
          随着我们业务的持续发展，当发生合并、收购、资产转让等交易导致向第三方共享或转移监护人和儿童的个人信息时，我们将通过推送通知、公告等形式告知监护人和儿童相关情形，按照法律法规及不低于本声明所要求的标准继续保护或要求新的管理者继续保护监护人和儿童的个人信息。
      </div>
       <div class="bold">
          一般情况下，我们禁止披露儿童个人信息，但我们可能基于以下目的使用儿童的个人信息：
      </div>
      <ul>
          <li class="text">遵守适用的法律法规等有关规定；</li>
          <li class="text">遵守法院判决、裁定或其他法律程序的规定；</li>
          <li class="text">遵守相关政府机关或其他法定授权组织的要求；</li>
          <li class="text">我们有理由确信需要遵守法律法规等有关规定；</li>
          <li class="text">为执行相关服务协议或本声明、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益合理且必要的用途。</li>
      </ul>
     <div class="section bold">
        存储儿童个人信息
      </div>
      <div class="text">
        我们会采取加密等技术措施存储儿童个人信息，确保信息安全。我们存储儿童个人信息，不会超过实现其收集、使用目的所必需的期限。请查阅<span class="herf" @click="toPrivacy()">《用户隐私协议》</span>“信息存储”、“信息保护”章节，详细了解我们如何存储和保护儿童个人信息。
      </div>
      <div class="text">
        当我们的产品和服务发生停止运营的情形或监护人和儿童的个人信息存储期限届满时，我们将采取例如，推送通知、公告等形式通知监护人和儿童，并在合理的期限内删除或匿名化处理监护人和儿童的个人信息。
      </div>
      <div class="section bold">
        更正、删除儿童个人信息
      </div>
      <div class="text">
        在儿童用户使用我们的产品和服务期间，为了监护人和儿童可以更加便捷地访问、更正、删除相关个人信息，我们在产品设计中为监护人提供了相应的操作设置，监护人也可以通过我们提供的联系方式，来反馈和咨询相关信息。我们会在核实监护人反馈的问题后及时与监护人联系。请监护人理解，在核实过程中，我们可能需要监护人提供儿童账号、儿童身份信息、联系方式等个人信息，以便在完成身份验证和核实问题后继续响应监护人的需求。
      </div>
      <div class="section bold">
        访问儿童个人信息
      </div>
      <div class="text">
        监护人和儿童可以查看儿童在使用我们产品和服务中提供或产生的个人信息，包括但不限于用户名、密码、头像、昵称、性别、主动发布的内容等。
      </div>
      <div class="section bold">
        更正儿童个人信息
      </div>
      <div class="text">
        当监护人和儿童发现我们收集、使用和处理的儿童个人信息有错误时，可以联系我们进行更正。我们会在完成身份验证和核实问题后，及时采取措施予以更正。
      </div>
      <div class="section bold">
        删除儿童个人信息
      </div>
      <div class="text">
        如存在以下情况，监护人和儿童可以联系我们删除收集、使用和处理的儿童个人信息。我们会在完成身份验证和核实问题后，及时采取措施予以删除：
      </div>
       <ul>
          <li class="text">若我们违反法律、行政法规的规定或者双方的约定收集、存储、使用、转移、披露儿童个人信息；</li>
          <li class="text">若我们超出目的范围或者必要期限收集、存储、使用、转移、披露儿童个人信息；</li>
          <li class="text">若监护人撤回同意；</li>
          <li class="text">若监护人或儿童通过注销等方式终止使用产品或者服务的。</li>
      </ul>
    <div class="bold">
        但请注意，若监护人和儿童要求我们删除特定儿童个人信息，可能导致该儿童用户无法继续使用我们的产品和服务或产品和服务中的某些具体业务功能。 如监护人发现在未事先征得监护人同意的情况下收集了儿童的个人信息，请及时联系我们，我们会采取措施尽快删除相关数据。
    </div>
    <div class="section bold">
        本声明的适用
      </div>
      <div class="text">
        请您理解，如本声明未规定之处，参照适用<span class="herf" @click="toPrivacy()">《用户隐私协议》</span>。
      </div>
      <div class="text">
        在适用本声明的情况下，如本声明与<span class="herf" @click="toPrivacy()">《用户隐私协议》</span>规定存在不一致的，以本声明为准。
      </div>
       <div class="section bold">
        联系我们
      </div>
      <div class="text">
        如您对本声明有任何疑问和反馈，请发送邮件至数据合规与隐私保护邮箱: privacy@teacat.com 与我们联系；
      </div>
      <div class="text">
        您也可按照我们提供的<span class="herf" @click="toProtect()">《个人信息咨询指引》</span> ，填写相关资料，将您的问题发送至
      </div>
      <div class="bold">
        privacy@teacat.com 
      </div>
      <div class="text">
        或寄到如下地址： 
      </div>
       <ul>
           <li class="text">地址：天津自贸试验区(空港经济区)环河北路与中心大道交口空港商务园东区2-1,2-201-1</li>
          <li class="text">技术保障部（收）</li>
          <li class="text">邮编：300308</li>
      </ul>
       <div class="text">
        我们将尽快审核所涉问题，并在接到投诉后的十五日内予以回复。 
      </div>
    </div>
  </div>
  </div>
</template>

<script>

export default {
  name: 'Privacy',
  methods: {
    toPrivacy () {
        this.$router.push({path: '/privacy'})
    },
    toProtect () {
         this.$router.push({path: '/protectInformation'})
    }
  }
}
</script>

<style scoped lang="scss">
.scroll-hide {
  width: 100%;
  height: 100vh;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
  overflow-y: scroll;
  position: fixed;
  position: -ms-device-fixed;
  top: 0px; left: 0px; right: 0px; bottom: 0px;
}
.privacy{
  padding: 32px;
  font-size: 24px;
  line-height: 40px;
  word-break: break-all;
  background: #F8F8F8;
  .bold{
    font-weight: bold !important;
    .child-herf {
      color: #346EF4;

    }
  }
  .title{
    font-size: 32px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 32px;
  }
  .header{
    font-weight: 500;
    color: #3A3B3C;
    border-bottom: 1px solid #eee;
    margin-bottom: 32px;
    line-height: 40px;
    .version{
       margin-bottom: 12px;
    }
    .updateTime{
       margin-bottom: 1px;
    }
    .effectiveTime{
       margin-bottom: 6px;
    }
  }
  .content{
    font-size: 24px;
    color: #3A3B3C;
    line-height: 48px;
    li {
        margin-left: 28px;
        list-style-type: disc;
    }
    .herf {
      color: #346EF4;

    }
    
    .section{
      margin: 24px 0 16px 0;
      line-height: 48px;
      font-size: 28px;
      font-weight: 500;
    }
    .text{
      font-size: 24px;
      font-weight: 400;
    }
    .interval {
        margin: 24px 0 0 0;
    }
  }
}
</style>
